/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Org_Profile_Updated_DescInputs */



/**
* | output |
* | --- |
* | "The organisation profile was changed - its name, description, website, theme colour or logo." |
*
* @param {Audit_Details_Org_Profile_Updated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_org_profile_updated_desc = /** @type {((inputs?: Audit_Details_Org_Profile_Updated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Org_Profile_Updated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Organisationsprofil wurde geändert - Name, Beschreibung, Website, Akzentfarbe oder Logo.")
	return /** @type {LocalizedString} */ ("The organisation profile was changed - its name, description, website, theme colour or logo.")
});